import React from 'react';
import { getTrackedUrl, isExternalUrl } from '../lib/outbound';
import { ExternalLink } from 'lucide-react';

/**
 * TrackedLink - A link component that automatically tracks external link clicks
 * 
 * Usage:
 * <TrackedLink href="https://example.com" source="adoption_agencies">
 *   Visit Website
 * </TrackedLink>
 */
const TrackedLink = ({ 
  href, 
  source = null, 
  campaign = null, 
  children, 
  className = '',
  showIcon = false,
  ...props 
}) => {
  const isExternal = isExternalUrl(href);
  const trackedHref = isExternal ? getTrackedUrl(href, source, campaign) : href;
  
  return (
    <a
      href={trackedHref}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      className={className}
      {...props}
    >
      {children}
      {showIcon && isExternal && (
        <ExternalLink className="inline-block w-3 h-3 ml-1" />
      )}
    </a>
  );
};

export default TrackedLink;
